<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import type { ISceneObj } from 'src/types/SceneType';
	import WhenStep from './WhenStep.svelte';
	import DoStep from './DoStep.svelte';

	export let scene_object: ISceneObj;
	export let stopConfirmationModal = false;

	const dispatch = createEventDispatcher();
</script>

<div class="automation-sequence">
	<section class="automation-section automation-section-when" aria-label="When and conditions">
		<WhenStep
			{stopConfirmationModal}
			bind:scene_object
			on:hide_footer={(event) => dispatch('hide_footer', event.detail)}
		/>
	</section>

	<div class="sequence-connector" aria-hidden="true">
		<span></span>
		<i class="fas fa-arrow-down"></i>
		<span></span>
	</div>

	<section class="automation-section automation-section-do" aria-label="Do actions">
		<DoStep
			{stopConfirmationModal}
			bind:scene_object
			on:hide_footer={(event) => dispatch('hide_footer', event.detail)}
		/>
	</section>
</div>

<style>
	.automation-sequence {
		display: flex;
		flex-direction: column;
		gap: 0;
		padding-bottom: 12px;
	}

	.automation-section {
		min-width: 0;
	}

	.sequence-connector {
		display: grid;
		grid-template-columns: 1fr auto 1fr;
		align-items: center;
		gap: 10px;
		padding: 0 24px;
		color: var(--color-2, #3b82f6);
	}

	.sequence-connector span {
		height: 1px;
		background: var(--color-3, rgba(148, 163, 184, 0.28));
	}

	.sequence-connector i {
		display: grid;
		place-items: center;
		width: 28px;
		height: 28px;
		border: 1px solid var(--color-3, rgba(148, 163, 184, 0.28));
		border-radius: 999px;
		background: var(--color-1, #fff);
	}
</style>
